import { logout, getInfo, login_with_sso } from '@/api/login'
import { getUserID, setUserID, removeUserID } from '@/utils/auth'

const user = {
  state: {
    username: '',
    user_id: getUserID(),
    superadmin: false,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERNAME: (state, name) => {
      state.username = name
    },
    SET_SUPERADMIN: (state, superadmin) => {
      state.superadmin = superadmin
    },
    SET_USER_ID: (state, user_id) => {
      state.user_id = user_id
      setUserID(user_id)
    }
  },

  actions: {
    // 登录
    LoginWithSSO({ commit }, ticket) {
      return new Promise((resolve, reject) => {
        login_with_sso(ticket).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          commit('SET_SUPERADMIN', data.is_superuser)  // 标记是否是超级管理员
          commit('SET_USERNAME', data.username)
          commit('SET_USER_ID', data.id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },


    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.user_id).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          commit('SET_SUPERADMIN', data.is_superuser)  // 标记是否是超级管理员
          commit('SET_USERNAME', data.username)
          commit('SET_USER_ID', data.id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.user_id).then(() => {
          // commit('user_id', '')
          removeUserID()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        // commit('user_id', '')
        removeUserID()
        resolve()
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js